import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReqObject } from '../dg-notings.component';
import { User } from '../../header/header.component';
import { map } from 'rxjs/operators';

declare global {
  interface Window {
    emp_stdNot: any;
    emp_stdComNot: any;
  }
}
window.emp_stdNot = [];
window.emp_stdComNot = [];
@Injectable({
  providedIn: 'root',
})
export class NotingsService {
  constructor(private http: HttpClient) {}
getNotings(requestObj: ReqObject): Observable<unknown> {
    let params: HttpParams;
    if (requestObj.myNoting) {
      params = new HttpParams()
        .set('recId', requestObj.recId.toString()) //2470 for attachment check
         .set('startIndex', requestObj.startIndex)
        .set('rowsPerPage', requestObj.rowsPerPage)
        .set('isPaginReq', requestObj.isPaginReq)
        .set('myNoting', requestObj.myNoting.toString())
        .set('noteTypeArr', requestObj.noteTypeArr); //requestObj.row.noteTypeArr);
    } else {
      params = new HttpParams()
        .set('recId', requestObj.recId.toString()) //2470 for attachment check
        .set('startIndex', requestObj.startIndex)
        .set('rowsPerPage', requestObj.rowsPerPage)
        .set('isPaginReq', requestObj.isPaginReq)
        .set('noteTypeArr', requestObj.noteTypeArr);
    }
 const url = '/case-mgmnt/notings';
    return this.http.get(url, { params: params });
  }

  methodForStdNot() {
    return this.http
      .get( `/admin/user-login-dtls`)
      .pipe(
        map(
          (response: { data: User; [key: string]: unknown }) => response?.data
        )
      );
  }

  getStdNot(empId) {
    return this.http.get('/core/standard-notings/' + empId);
  }
  getStdComNot() {
    return this.http.get('/core/common-notings/1');
  }
}
